import {createGlobalStyle} from 'styled-components';

export const GlobalStyleQrvey = createGlobalStyle`
/**
 * Hide Qrvey's toast.
 * The reason for always applying this styling, and not only when rendering the Qrvey report,
 * is that the toasts might still be visible _after_ the user navigates away from the report.
 */
qui-toast {
    display: none;
}
`;
